export const JSON_REQUEST = 'application/json';
export const MULTIPART_REQUEST = 'multipart/form-data';



// WEBPACK FOOTER //
// ./src/api/helpers/requestTypes.js